<template>
  <div class="footer">
    <div class="contain">
      <!-- <div class="box" style="width:30%;padding: 0 40px 0 0">
        <span class="title">企业简介</span>
        <span class="content">周口市国恒医药销售有限公司，成立于2014年，位于河南省周口市，是一家以从事批发业为主的企业。企业注册资本3000万人民币，实缴资本3000万人民币。 -->
      <!-- <router-link
            to="/companyIntro">[详情]</router-link> -->
      <!-- </span>
      </div> -->
      <div class="box" style="width:25%">
        <span class="title">联系我们</span>
        <div class="content1">
          <span>公司名称：{{ companyInfo.name }}</span>
          <span>公司地址：{{ companyInfo.address }}</span>
          <span>电话：{{ companyInfo.contactInformation }}</span>
        </div>
      </div>

      <div class="box" style="width:20%">
        <div class="content1" style="margin-top: 22px">
          <!-- <span>邮编：471000</span> -->
          <span>邮箱：{{ companyInfo.email }}</span>
          <!-- <span>网址：www.lyjxrf.com/</span> -->
        </div>
      </div>
      <!-- <div class="box">
        <span class="title">相关产品连接</span>
        <div class="content1">
          <span><a href="http://ds.lyjxrf.com" class="bottomStyle" target="_blank">电商平台</a></span>
          <span><a href="http://lyjxrf.com/bjb/#/login" class="bottomStyle" target="_blank">比价宝</a></span>
        </div>
      </div> -->
      <!-- <div>
        <img style="width: 100px" src="../../assets/images/bottomImg/DSlogo.png" />
      </div> -->
    </div>
    <div class="bottom">
      <div class="bottomStyle">
        <!-- <a href="https://beian.miit.gov.cn/" target="_blank">网站备案号：{{ companyInfo.websiteRegistrationNumber }}</a> -->
        <a v-if="companyInfo.websiteRegistrationNumber" target="_blank" href="https://beian.miit.gov.cn/"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;width: 250px">
          <p style="height:20px;line-height:20px; color:#939393; text-align: left;">
            ICP备案号：{{ companyInfo.websiteRegistrationNumber }}
          </p>
        </a>
        <a v-if="companyInfo.qualificationCertificateNumber" target="_blank" href="https://www.nmpa.gov.cn/datasearch/search-result.html"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px; min-width: 250px">
          <p style="height:20px;line-height:20px; color:#939393; text-align: left;">
            互联网药品信息服务资格证编号：{{ companyInfo.qualificationCertificateNumber }}
          </p>
        </a>
      </div>
    </div>

    <div class="bahStyle">
      <a v-if="companyInfo.networkSecurityRegistrationNumber" target="_blank" :href="gongAnHref"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;width: 250px; margin-left: 20px;">
          <img src="../../assets/images/bottomImg/bah.png" style="float: left; margin-right: 5px;" />
          <p style="height:20px;line-height:20px; color:#939393; text-align: left;">
            {{ companyInfo.networkSecurityRegistrationNumber }}
          </p>
        </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      IS_SHOW_BAH: window.IS_SHOW_BAH,
      BAH: window.BAH,
      companyInfo: {},
      gongAnHref: ''
    };
  },
  created() {
    this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'))
    this.gongAnHref = "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" + this.companyInfo.networkSecurityRegistrationNumber
    console.log(this.gongAnHref)
  }
};
</script>

<style scoped>
a {
  color: #0068b7;
}

.footer {
  /* background: #efefef; */
  background-image: url("../../assets/images/homePic/1.png");
  background-size: cover;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0 0 0;
  color: #000;
  /* opacity: .5;  */
}

.contain {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  line-height: 25px;
}

.box {
  width: 25%;
  display: block;
  display: flex;
  flex-direction: column;
}

.title {
  width: 100%;
  font-weight: 800;
  font-size: 20px;
}

.content {
  margin-top: 5px;
  font-size: 12px;
  text-align: left;
}

.content1 {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.footer p {
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-size: 14px;
}

.bottom {
  display: flex;
  justify-content: space-around;
  background: #333;
  height: 40px;
  line-height: 40px;
}

.bottomStyle {
  /* margin: 0 auto;
  border: 1px solid #f00; */
  /* margin-top: 20px; */
  color: #000;
}

.bottomStyle>a:hover {
  color: #409eff;
  cursor: pointer;
}

.bahStyle {
  margin-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}
</style>
